import { post, get, wordpost } from '../network/index.js'
//会员等级列表
const levelList = data => {
  return get('/userMemberLevel/levelList', data)
}
//会员等级详情
const queryLevelInfo = data => {
  return get('/userMemberLevel/detail', data)
}
// 用户-解绑微信小程序
const unbindWxApp = data => {
  return post('/userMemberLevel/unbindWx', data)
}
//会员编辑
const levelUpdate = data => {
  return post('/userMemberLevel/levelUpdate', data)
}

//会员等级变更记录
const levelChangeList = data => {
  return post('/userMemberLevel/levelChangeList', data)
}
//会员经验值记录
const ExperienceValueList = data => {
  return post('/userMemberLevel/ExperienceValueList', data)
}
//设置会员等级开启
const isOpenLevel = data => {
  return post('/userMemberLevel/isOpenLevel', data)
}

//新增商品
const addPointProduct = data => {
  return post('/integralCommodityManage/add', data)
}
//商品列表
const pointProductList = data => {
  return post('/integralCommodityManage/list', data)
}
//商品排序
const pointProductSort = data => {
  return post('/integralCommodityManage/commodityBy', data)
}
//商品数量统计
const countGroupInfo = data => {
  return post('/integralCommodityManage/countGroupInfo', data)
}
//商品修改状态
const integralUpdate = data => {
  return post('/integralCommodityManage/integralUpdate', data)
}
//商品详情
const pointProductDetail = data => {
  return get('/integralCommodityManage/detail', data)
}
//商品删除
const deleteIntegra = data => {
  return post('/integralCommodityManage/deleteIntegra', data)
}

//商户积分规则查询
const getInitRule = data => {
  return get('/integralMange/getInitRule', data)
}
//积分记录
const integralList = data => {
  return post('/integralMange/integralList', data)
}
//积分兑换记录
const exchangeList = data => {
  return post('/integralMange/exchangeList', data)
}
//手动增减积分
const updateIntegral = data => {
  return post('/integralMange/updateIntegral', data)
}
//修改商户积分规则
const updateRule = data => {
  return post('/integralMange/updateRule', data)
}
//新增分组
const groupAdd = data => {
  return post('/commodityGroup/add', data)
}
const groupUpdate = data => {
  return post('/commodityGroup/update', data)
}
// 分组查询(带分页)
const groupList = data => {
  return post('/commodityGroup/queryList', data)
}
const groupListAll = data => {
  return post('/commodityGroup/queryListAll', data)
}
const groupDelete = data => {
  return post('/commodityGroup/delete', data)
}
const groupOrderBy = data => {
  return post('/commodityGroup/groupOrderBy', data)
}

export default {
  levelList,
  queryLevelInfo,
  unbindWxApp,
  levelUpdate,
  levelChangeList,
  ExperienceValueList,
  isOpenLevel,
  addPointProduct,
  pointProductList,
  pointProductSort,
  countGroupInfo,
  integralUpdate,
  pointProductDetail,
  deleteIntegra,
  getInitRule,
  integralList,
  exchangeList,
  updateIntegral,
  updateRule,
  groupAdd,
  groupUpdate,
  groupList,
  groupListAll,
  groupDelete,
  groupOrderBy
}
